module.exports = __webpack_public_path__ + "static/img/nav_logo_title.a9712b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/nav_logo_title.png
// module id = 7Z+m
// module chunks = 16